import React from 'react';
import PropTypes from 'prop-types';

import Badge from 'wonderbly-components/lib/Badge';
import { prismicImage } from 'src/common/utils/prismic-image';

import './Product.scss';
import Price from '../../Price';

const Product = props => (
  <a href={props.link} className="product-item-link">
    <div className="product-item">
      {props.badge && <Badge absolute icon="star">
        {props.badge}
      </Badge>}
      <div
        className="product-item-image"
        style={{
          backgroundColor: props.imageBackgroundColor,
        }}>
        <img src={prismicImage(props.image)} alt="" />
      </div>
      <div className="product-item-content">
        <span className="product-item-age-range">{props.ageString}</span>
        <h5 className="text-kilo product-item-title">{props.title}</h5>
        <p className="product-item-description">
          {props.description}
        </p>
        {!props.isPriceHidden && (
          <Price
            className="product-item-price"
            price={props.price}
            priceString={props.priceString}
            savings={props.savings}
            savingsType="slash"
          />
        )}
      </div>
    </div>
  </a>
);

Product.propTypes = {
  image: PropTypes.object.isRequired,
  imageBackgroundColor: PropTypes.string.isRequired,
  badge: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  ageString: PropTypes.string.isRequired,
  priceString: PropTypes.string.isRequired,
  isPriceHidden: PropTypes.bool.isRequired,
  link: PropTypes.string.isRequired,
  price: PropTypes.object.isRequired,
  savings: PropTypes.object
};

export default Product;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductList/Product/Product.js